import { AuthService } from '../commons/services/auth.service';
import { AirlineService } from '../commons/services/airline.service';
import { ILanguagesService } from '../commons/services/languages.service.upgrade';
import { IUserProfile } from '../types/user';
import { InjectionToken } from '@angular/core';
import { IAirline } from 'app/types/airline';
import { ProviderLike, Transition } from '@uirouter/angular';
import { ILanguage } from 'app/types/language';
import { LanguagesService } from 'app/commons/services/languages.service';
import { ISidebarOptions } from 'app/types/menu';

export const currentUserToken = new InjectionToken<IUserProfile>("userProfile");

export const currentUserProvider: ProviderLike = {
  provide: currentUserToken,
  useFactory: (authService: AuthService) => authService.getUserProfileSync(),
  deps: [
    AuthService
  ]
}

/** @deprecated */
export const currentUserCompatibilityProvider: ProviderLike = {
  provide: "currentUser",
  useExisting: currentUserToken
}

export const tenantsToken = new InjectionToken<IAirline[]>("tenants");

export const tenantsProvider: ProviderLike = {
  provide: tenantsToken,
  useFactory: (AirlineService: AirlineService, profile: IUserProfile) => AirlineService.getAirlineList(profile.grantedTenants),
  deps: [
    AirlineService,
    currentUserToken
  ]
}

/** @deprecated */
export const airlinesCompatibilityProvider: ProviderLike = {
  provide: "airlines",
  useExisting: tenantsToken
}

export const languagesToken = new InjectionToken<ILanguage[]>("languages");

export const languagesProvider: ProviderLike = {
  provide: languagesToken,
  useFactory: (languagesService: ILanguagesService) => languagesService.getAirlineLanguages(),
  deps: [
    LanguagesService
  ]
}

/** @deprecated */
export const languagesCompatibilityProvider: ProviderLike = {
  provide: "languages",
  useExisting: languagesToken
}

export const currentTenantToken = new InjectionToken<IAirline>("currentTenant");

export const currentTenantProvider: ProviderLike = {
  provide: currentTenantToken,
  useFactory: (AirlineService: AirlineService) => AirlineService.currentAirline,
  deps: [
    AirlineService,
    tenantsToken
  ]
}

/** @deprecated */
export const currentAirlineCompatibilityProvider: ProviderLike = {
  provide: "currentAirline",
  useExisting: currentTenantToken
}

export const currentLanguageToken = new InjectionToken<ILanguage>("currentLanguage");

export const currentLanguageProvider: ProviderLike = {
  provide: currentLanguageToken,
  useFactory: (languagesService: ILanguagesService) => languagesService.currentLanguage,
  deps: [
    LanguagesService,
    languagesToken
  ]
}

/** @deprecated */
export const currentLanguageCompatibilityProvider: ProviderLike = {
  provide: "currentLanguage",
  useExisting: currentLanguageToken
}

export const sessionTimeoutToken = new InjectionToken<number>("sessionTimeout");

export const sessionTimeoutProvider: ProviderLike = {
  provide: sessionTimeoutToken,
  useFactory: (authService: AuthService) => authService.getUserSessionTimeout(),
  deps: [
    AuthService
  ]
}

/** @deprecated */
export const sessionTimeoutCompatibilityProvider: ProviderLike = {
  provide: "sessionTimeout",
  useExisting: sessionTimeoutToken
}

export const menuOptionsToken = new InjectionToken<ISidebarOptions>("menuOptions");

export const menuOptionsProvider: ProviderLike = {
  provide: menuOptionsToken,
  useFactory: ($transition$: Transition) => $transition$.params().menuOptions,
  deps: [
    Transition
  ]
}

/** @deprecated */
export const menuOptionsCompatibilityProvider: ProviderLike = {
  provide: "menuOptions",
  useExisting: menuOptionsToken
}
